import { createFileRoute } from "@tanstack/react-router";
import senceImg from "@/assets/sence-cursos.webp.asset.json";

export const Route = createFileRoute("/cursos/personas/sence")({
  head: () => ({
    meta: [
      { title: "Cursos SENCE | Mine Class" },
      {
        name: "description",
        content:
          "Cursos gratuitos SENCE en alianza con MineClass: formación minera y transformación digital, en línea y con cupos ilimitados.",
      },
      { property: "og:title", content: "Cursos SENCE Gratuitos | Mine Class" },
      { property: "og:description", content: "Cursos SENCE gratuitos en línea con MineClass para fortalecer competencias en minería y transformación digital." },
      { property: "og:type", content: "website" },
    ],
  }),
  component: SenceContent,
});

function SenceContent() {
  return (
    <div className="space-y-8">
      <div className="relative overflow-hidden rounded-2xl aspect-[16/9] bg-[var(--color-brand-purple)]">
        <img
          src={senceImg.url}
          alt="Alianza SENCE y MineClass: cursos gratuitos para la minería"
          className="absolute inset-0 w-full h-full object-cover"
        />
      </div>

      <div>
        <span className="text-[10px] uppercase tracking-widest font-bold text-[var(--color-brand-coral)]">
          Alianza SENCE
        </span>
        <h2 className="text-2xl md:text-3xl font-bold text-[var(--color-brand-purple)] mt-1">
          Cursos SENCE Gratuitos
        </h2>
        <p className="text-[var(--color-on-surface-variant)] mt-3 text-base md:text-lg leading-relaxed">
          La alianza entre el Servicio Nacional de Capacitación y Empleo (SENCE) con MineClass,
          OTEC líder en formación minera en Latinoamérica, ofrece diez cursos gratuitos, en línea y
          con cupos ilimitados, orientados a fortalecer las competencias laborales en el sector
          minero y la transformación digital.
        </p>

        <a
          href="https://eligetucurso.sence.cl/?campaign=MINE_CLASS"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-5 inline-flex items-center gap-2 px-5 py-2.5 bg-[var(--color-brand-coral)] text-white text-xs font-bold uppercase tracking-widest rounded-full hover:bg-[var(--color-brand-purple)] transition-colors"
        >
          Ver cursos SENCE
          <span className="material-symbols-outlined text-base">arrow_outward</span>
        </a>
      </div>
    </div>
  );
}
